export const themes = {
    light: {
      color: "#1D0D50",
      background: "#B3D6e0",
      cardGradient:
        "linear-gradient(to bottom, rgba(117,180,255,0.9) 0%, rgba(207,255,237,1) 100%)",
      buttonColor: '#1D0D50',
      buttonBackground: '#86BDFF',
      sidebarBackground: "#B3D6FF",
      sidebarNavBackground: "#348FFC"
    },
    dark: {
      color: "#F3F8FF",
      background: "#100536",
      cardGradient: "linear-gradient(to bottom, #1d0d50 0%, #5c33a7 80%)",
      buttonColor: '#B3D6e0',
      buttonBackground: '#5c33a7',
      sidebarBackground: "#493882",
      sidebarNavBackground: "#32206B"
    },
  };